/**
 * @solote/contracts
 *
 * Fonte unica da verdade entre o painel administrativo (que produz
 * configuracao), o front-end publico (que a interpreta) e os servicos de
 * backend (que a validam). Nenhum dos tres redefine estes tipos localmente.
 */

export * from './primitives.js';
export * from './fields.js';
export * from './site-config.js';
export * from './commerce.js';
export * from './rules.js';
export * from './listing.js';
export * from './search.js';
export * from './match.js';
export * from './crm.js';
export * from './permissions.js';
export * from './payments.js';
export * from './expression.js';
export * from './admin.js';

import { z } from 'zod';
import { siteConfig } from './site-config.js';
import { commerceConfig } from './commerce.js';
import { rulesConfig } from './rules.js';
import { searchConfig } from './search.js';
import { matchConfig } from './match.js';
import { crmConfig } from './crm.js';
import { accessConfig } from './permissions.js';
import { fieldOption, formSchema } from './fields.js';

/**
 * Envelope completo entregue ao cliente em GET /api/v1/bootstrap.
 * Uma requisicao, tudo que o app precisa para se montar.
 */
export const bootstrapConfig = z.object({
  site: siteConfig,
  commerce: commerceConfig,
  rules: rulesConfig,
  search: searchConfig,
  match: matchConfig,
  crm: crmConfig,
  /** Catalogo de permissoes e perfis internos (Cap. 4 e 24). */
  access: accessConfig,
  /** Formularios publicados, indexados por chave. */
  forms: z.record(z.string(), formSchema).default({}),
  /**
   * Listas de dominio mantidas em /admin/taxonomias: topografia,
   * infraestrutura, aptidao, documentacao, motivos de denuncia. Campos
   * apontam para elas por chave, entao acrescentar "Poco artesiano" atualiza
   * de uma vez o cadastro, os filtros e o match.
   */
  taxonomies: z.record(z.string(), z.array(fieldOption)).default({}),
  /** ETag da composicao — muda a cada publicacao do painel. */
  etag: z.string(),
});

export type BootstrapConfig = z.infer<typeof bootstrapConfig>;
